import { render } from "./RenderingRandselPocket.vue?vue&type=template&id=96ebe910&ts=true"
import script from "./RenderingRandselPocket.vue?vue&type=script&lang=ts"
export * from "./RenderingRandselPocket.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__